import { render, staticRenderFns } from "./NotificationsSettings.vue?vue&type=template&id=018934cf&scoped=true"
import script from "./NotificationsSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationsSettings.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NotificationsSettings.vue?vue&type=style&index=0&id=018934cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018934cf",
  null
  
)

export default component.exports